{
  "checkRiskRejected": "这段内容不太合适，咱们换个话题聊聊吧～",
  "_supportedFileTypes": "jpg、png、bmp、webp、heic、doc、docx、xls、xlsx、ppt、pptx、pdf",
  "fileFilteredTip": "仅支持 $t(_supportedFileTypes) 格式且大小不超过 {{maxSize}}MB 的文件，请重新选择",
  "stepNames": {
    "generate_form_name": "生成表单标题",
    "generate_form_title": "生成表单标题",
    "generate_form_description": "生成表单描述",
    "generate_form_fields": "生成表单字段",
    "update_form_fields": "更新表单字段",
    "generate_form_header_image": "生成表单头图",
    "analyze_create_form_requirement": "分析需求",
    "generate_raw_exam_content_from_subject": "生成考试",
    "create_form": "创建表单",
    "update_form": "更新表单",
    "duplicate_form": "创建表单",
    "search_image": "搜索图片",
    "inquiry": "搜索文档",
    "parse_image": "查看图片",
    "scrape_url": "查看网页"
  },
  "statusDisplay": {
    "parse_image": "👀 正在查看图片",
    "scrape_url": "👀 正在查看网页",
    "parse_pdf": "👀 正在查看文档",
    "parse_word": "👀 正在查看文档",
    "parse_excel": "👀 正在查看文档",
    "parse_ppt": "👀 正在查看文档",
    "analyze_create_form_requirement": "🤔 正在分析",
    "create_exam_from_subject": "🤔 正在生成考试",
    "create_evaluation_from_subject": "🤔 正在生成测评",
    "generate_raw_exam_content_from_subject": "🤔 正在生成题目",
    "create_form": "✒️ 正在生成表单",
    "duplicate_form": "✒️ 正在生成表单",
    "update_form": "🔄 正在更新表单",
    "update_form_fields": "✒️ 正在更新字段",
    "add_form_fields": "➕ 正在添加字段",
    "generate_field_rules": "🔄 正在生成字段规则",
    "_after_content_fetched": "🧐 正在分析内容"
  },
  "stepErrorMessages": {
    "scrape_url": "查看网页时发生错误，请检查输入的网址是否正确，并确认该网站可以访问"
  },
  "errorOccurred": "系统错误，请重试",
  "errorOccurredWithStep": "{{step}}时发生错误",
  "networkError": "网络错误，请稍后重试",
  "agcWarning": "内容由 AI 生成，请仔细甄别生成结果"
}
